import { render, staticRenderFns } from "./TemplateGrid.vue?vue&type=template&id=50f096c9&scoped=true&"
import script from "./TemplateGrid.vue?vue&type=script&lang=js&"
export * from "./TemplateGrid.vue?vue&type=script&lang=js&"
import style0 from "./TemplateGrid.vue?vue&type=style&index=0&id=50f096c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f096c9",
  null
  
)

export default component.exports